import { rebuildFieldTypesConfig } from '@databases/fields';

/**
 * Rebuilds field metadata after feature flags initialize.
 */
export function initializeFieldTypesConfig(): void {
  rebuildFieldTypesConfig();
}
